module.exports = __webpack_public_path__ + "img/img_covertack_emblem.001be579.png";